import { render, staticRenderFns } from "./NewSystem.vue?vue&type=template&id=60d74995&scoped=true"
import script from "./NewSystem.vue?vue&type=script&lang=js"
export * from "./NewSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d74995",
  null
  
)

export default component.exports